import GitHubIcon from '@/assets/connectors/github.svg?react'
import GitLabIcon from '@/assets/connectors/gitlab.svg?react'
import BitbucketIcon from '@/assets/connectors/bitbucket.svg?react'
import AzureDevOpsIcon from '@/assets/connectors/azuredevops.svg?react'
import JiraIcon from '@/assets/connectors/jira.svg?react'
import FigmaIcon from '@/assets/connectors/figma.svg?react'
import SonarQubeIcon from '@/assets/connectors/sonarqube.svg?react'
import AnthropicIcon from '@/assets/connectors/anthropic.svg?react'
import GitHubCopilotIcon from '@/assets/connectors/githubcopilot.svg?react'
import { Cpu as QubizTitanIcon, Database } from 'lucide-react'
import type { ConnectorType } from '@/types'

export const CONNECTOR_ICONS: Record<ConnectorType, React.ElementType> = {
  GitHub: GitHubIcon,
  GitLab: GitLabIcon,
  Bitbucket: BitbucketIcon,
  AzureDevOps: AzureDevOpsIcon,
  Jira: JiraIcon,
  Figma: FigmaIcon,
  SonarQube: SonarQubeIcon,
  RelationalDatabase: Database,
  Anthropic: AnthropicIcon,
  GitHubCopilot: GitHubCopilotIcon,
  QubizTitan: QubizTitanIcon,
}
